import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { from, Observable, of } from 'rxjs';
import { RootState } from '..';
import { AzureMonitoringService } from '../../services/AzureMonitoringService';
import { CCRRestService } from '../../services/rest/ccr.rest.service';
import { OrderRestService } from '../../services/rest/order.rest.service';
import { AbstractEffects } from '../AbstractEffects';
import * as actions from './ccr-detail.actions';
import { CCRDetailCreateSubmitAction, CCRDetailEditSubmitAction } from './ccr-detail.actions';
import { catchError, debounceTime, switchMap, withLatestFrom } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class CCRDetailEffects extends AbstractEffects {
  createCCR$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<CCRDetailCreateSubmitAction>(actions.CCRDETAIL_CREATE_SUBMIT),
      debounceTime(50),
      withLatestFrom(this.store, (action, state) => {
        return { action, state };
      }),
      switchMap(actionAndState => {
        return this.ccrRestService.createCCR(actionAndState.action.payload).pipe(
          switchMap(result => {
            return from([new actions.CCRDetailCreateSubmitSuccessAction( result )]);
          }),
          catchError(err => this.handleFail(err, 'Submit ccr', [of(new actions.CCRDetailCreateSubmitFailAction(err))]))
        );
      })
    )
  );

  editCCR$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<CCRDetailEditSubmitAction>(actions.CCRDETAIL_EDIT_SUBMIT),
      debounceTime(50),
      withLatestFrom(this.store, (action, state) => {
        return { action, state };
      }),
      switchMap(actionAndState => {
        return this.ccrRestService.editCCR(actionAndState.action.payload).pipe(
          switchMap(result => {
            return from([new actions.CCRDetailEditSubmitSuccessAction( result )]);
          }),
          catchError(err => this.handleFail(err, 'Submit ccr', [of(new actions.CCRDetailEditSubmitFailAction(err))]))
        );
      })
    )
  );

  constructor(
    private store: Store<RootState>,
    azureMonitoringService: AzureMonitoringService,
    private actions$: Actions,
    private orderRestService: OrderRestService,
    translateService: TranslateService,
    private ccrRestService: CCRRestService,
    notificationService: NotificationService
  ) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
